function mimeTypeFromUrl(url) {
  const u = String(url || '').toLowerCase().split('?')[0];
  if (u.endsWith('.png')) return 'image/png';
  if (u.endsWith('.svg')) return 'image/svg+xml';
  if (u.endsWith('.webp')) return 'image/webp';
  if (u.endsWith('.ico')) return 'image/x-icon';
  if (u.endsWith('.jpg') || u.endsWith('.jpeg')) return 'image/jpeg';
  return 'image/png';
}

function resolvePublicUrl(path) {
  const p = String(path || '').trim();
  if (!p) return '';
  if (/^https?:\/\//i.test(p) || p.startsWith('data:')) return p;
  const base = (process.env.PUBLIC_URL || '').replace(/\/$/, '');
  return p.startsWith('/') ? `${base}${p}` : `${base}/${p}`;
}

/**
 * Título de pestaña y favicon según config del cliente (name_company, app_logo).
 */
export function applySiteBranding(config) {
  if (typeof document === 'undefined' || !config) return;

  const nombreClinica = (config.name_company || 'Clínica').trim();
  if (nombreClinica) {
    document.title = nombreClinica;
  }

  const faviconSrc = resolvePublicUrl(
    (config.app_logo || config.app_favicon || '').trim()
  );
  if (!faviconSrc) return;

  const type = mimeTypeFromUrl(faviconSrc);
  const rels = ['icon', 'shortcut icon', 'apple-touch-icon'];

  rels.forEach((rel) => {
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement('link');
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = faviconSrc;
    if (rel !== 'apple-touch-icon') {
      link.type = type;
    }
  });
}

export default applySiteBranding;
